import NewPasswordModule from '@/modules/new-password';

export default NewPasswordModule;
